export default __webpack_public_path__ + "static/media/PL001.2.81ab1d72.mp3";